import { navLinks } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <span className="w-8 h-8 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-base">
                <i className="ri-eye-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">吃瓜捷克</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              一份围绕吃瓜捷克的资料速查单页：汇总个人资料、年龄线索、照片物料与微博抖音账号动向，
              帮你快速了解这位热门人物的真实背景与网络踪迹。
            </p>
          </div>

          <div className="flex flex-wrap gap-x-10 gap-y-6">
            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">栏目导航</h4>
              <ul className="space-y-2">
                {navLinks.slice(0, 3).map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-3">更多内容</h4>
              <ul className="space-y-2">
                {navLinks.slice(3).map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-700 transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 leading-relaxed max-w-2xl">
            本站为静态资料整理演示页面，内容来自公开动态汇总与网络考古，均标注来源性质。
            涉及真实身份、年龄与照片的信息未经核实，请以本人认证账号发布内容为准，请勿传播未经证实的说法。
          </p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">© 2026 吃瓜捷克 · 资料速查</p>
        </div>
      </div>
    </footer>
  );
}